/**
 * HTTP-Status einer abgelehnten API-Anfrage.
 *
 * Der Interceptor in services/api.ts lehnt nicht mit dem Axios-Fehler ab, sondern mit
 * `{message, code, originalError}`; `err.response` ist dort undefined. Gelesen werden
 * beide Formen, damit auch ein direkter Axios-Fehler erkannt wird.
 */
export const apiErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') return undefined;
  const e = error as {
    code?: unknown;
    response?: { status?: number };
    originalError?: { response?: { status?: number } };
  };
  if (typeof e.code === 'number') return e.code;
  return e.response?.status ?? e.originalError?.response?.status;
};
